import type { ComponentWithAs, IconProps } from "@chakra-ui/react";
import { ScannerIcon, UploadIcon } from "./Icons";

type Config = {
  icon: ComponentWithAs<"svg", IconProps>;
  text: string;
  eventLabel: "CheckYourCompensationBarcode" | "CheckYourCompensationUploader";
  destination: "webappBarcodeScanner" | "webappBarcodeUploader";
};

export const config: Record<"uploader" | "scanner", Config> = {
  uploader: {
    eventLabel: "CheckYourCompensationUploader",
    destination: "webappBarcodeUploader",
    text: "Upload boarding pass",
    icon: UploadIcon,
  },
  scanner: {
    eventLabel: "CheckYourCompensationBarcode",
    destination: "webappBarcodeScanner",
    text: "Scan boarding pass barcode",
    icon: ScannerIcon,
  },
};
